<script>
import Vue from 'vue';
import {mapActions, mapState} from 'vuex';
import store from '../../store';
import Loading from '../Loading/Loading.vue'

export default Vue.extend({
    components: {
        Loading
    },
    computed: {
        ...mapState({
            error: state => state.introduction.confirmation.error,
            warning: state => state.introduction.confirmation.warning,
            loading: state => state.introduction.confirmation.loading,
            noContent: state => state.introduction.confirmation.noContent
        })
    },
    methods: {
        ...mapActions({
            sendConfirmation: 'introduction/sendConfirmation'
        })
    },
    beforeRouteEnter(to, from, next) {
        const confirmationToken = to.params.confirmationToken;
        store.dispatch('introduction/sendConfirmation', confirmationToken);
        next();
    }
});
</script>
<template>
    <div class="introduction-accept-page">
        <loading v-if="loading"/>
        <div v-if="!loading" class="introduction-accept-page__content">
            <div class="introduction-accept-page__heading">
                <div class="introduction-accept-page__header">
                    <span v-if="!error && !warning && !noContent">{{ $t('introduction.header.heading') }}</span>
                    <span v-if="error">{{ $t('introduction.header.error') }}</span>
                    <span v-if="warning">{{ $t('introduction.header.warning') }}</span>
                    <span v-if="noContent">{{ $t('introduction.header.noContent') }}</span>
                </div>
            </div>
            <div class="introduction-accept-page__body">
                <span v-if="!error && !warning && !noContent">{{ $t('introduction.body') }}</span>
                <span v-if="error">{{ $t('introduction.error') }}</span>
                <span v-if="warning">{{ $t('introduction.warning') }}</span>
                <span v-if="noContent">{{ $t('introduction.noContent') }}</span>
            </div>
            <div class="introduction-accept-page__footer">
                <div class="introduction-accept-page__field introduction-acceot-page__header-field">
                    {{ $t('introduction.footer.title') }}
                </div>
                <div class="introduction-accept-page__field"><strong>{{ $t('introduction.footer.contact.title') }}</strong></div>
                <div class="introduction-accept-page__field">{{ $t('introduction.footer.contact.address') }}</div>
                <div class="introduction-accept-page__field">{{ $t('introduction.footer.contact.street') }}</div>
                <div class="introduction-accept-page__field">{{ $t('introduction.footer.contact.city') }}</div>
                <div class="introduction-accept-page__field">{{ $t('introduction.footer.contact.country') }}</div>
                <div class="introduction-accept-page__field">{{ $t('introduction.footer.contact.tel') }}</div>
                <div class="introduction-accept-page__field">{{ $t('introduction.footer.contact.email') }}</div>
            </div>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/IntroductionAcceptPage/IntroductionAcceptPage.vue